import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=0aa5ce98"
import script from "./Place.vue?vue&type=script&lang=js"
export * from "./Place.vue?vue&type=script&lang=js"
import style0 from "./Place.vue?vue&type=style&index=0&id=0aa5ce98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports